/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSubscriptionQuoteData
 */
export interface CreateSubscriptionQuoteData {
    /**
     * 
     * @type {number}
     * @memberof CreateSubscriptionQuoteData
     */
    billingPackageId: number;
}

/**
 * Check if a given object implements the CreateSubscriptionQuoteData interface.
 */
export function instanceOfCreateSubscriptionQuoteData(value: object): value is CreateSubscriptionQuoteData {
    if (!('billingPackageId' in value) || value['billingPackageId'] === undefined) return false;
    return true;
}

export function CreateSubscriptionQuoteDataFromJSON(json: any): CreateSubscriptionQuoteData {
    return CreateSubscriptionQuoteDataFromJSONTyped(json, false);
}

export function CreateSubscriptionQuoteDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSubscriptionQuoteData {
    if (json == null) {
        return json;
    }
    return {
        
        'billingPackageId': json['billingPackageId'],
    };
}

  export function CreateSubscriptionQuoteDataToJSON(json: any): CreateSubscriptionQuoteData {
      return CreateSubscriptionQuoteDataToJSONTyped(json, false);
  }

  export function CreateSubscriptionQuoteDataToJSONTyped(value?: CreateSubscriptionQuoteData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingPackageId': value['billingPackageId'],
    };
}

